import {
  applySnapshot,
  Instance,
  SnapshotIn,
  SnapshotOut,
  getParent,
  flow,
  types,
} from 'mobx-state-tree';
import { debug, request } from 'lib';

const log = debug.create('medal');
const error = debug.create('medal:error');

const initState = {
  allMedals: [],
};

const MedalInfoModel = types.model('MedalInfoModel', {
  _id: 0,
  desc: '',
  stime: 0,
  status: false,
  is_mvip: false,
  type: 0,
  pic_url: '',
  timestamp: 0,
  grey_pic: '',
  etime: 0,
  medal_type: 0,
  name: '',
  small_pic: '',
});

const Model = types
  .model('MedalModel', {
    allMedals: types.array(MedalInfoModel),
  })
  .views((self) => {
    return {};
  })
  .actions((self) => {
    const init = flow(function* () {
      let res;
      try {
        res = yield request.api.get(`show/medals_list`);

        self.allMedals = res.all_medals;

        log('update room success');
      } catch (e) {
        error('update room error', e);
      }
    });

    const filter = (medalList = []) => {
      var ary = [];

      for (var i = 0, l = medalList.length; i < l; i++) {
        var item = medalList[i];

        if (
          item.type == 1 ||
          (item.medal_type == 2 && !item.award) ||
          item.medal_type == 3
        ) {
          continue;
        } else {
          ary.push(item);
        }
      }

      return ary;
    };

    const getLastTime = (time) => {
      var result = {
        day: Math.floor(time / (1000 * 60 * 60 * 24)),
        hour: Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      };
      var str = '';
      if (result.day > 0) {
        str += result.day + '天';
      }
      if (result.hour > 0) {
        str += result.hour + '小时';
      }
      if (result.day === 0 && result.hour === 0) {
        str = '1小时';
      }
      return str;
    };
    const getExpireTimeStr = (time, isAward) => {
      if (isAward) {
        return '';
      }
      if (time < 0) {
        return '';
      }
      var hours = Math.floor(time / 3600);
      if (hours > 0) {
        return '（剩余' + hours + '小时）';
      }
      var minutes = Math.floor(time / 60);
      return '（剩余' + minutes + '分钟）';
    };
    return {
      init,
      filter,
      getLastTime,
      getExpireTimeStr,
    };
  });

export default {
  initState,
  Model,
  MedalInfoModel,
};
